import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/MSFTheme";

import DashboardIcon from "@mui/icons-material/Dashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FeedbackIcon from "@mui/icons-material/Feedback";

const MSFMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/msf",
            label: "Dashboard",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/msf/surveys",
            label: "Surveys",
            icon: (
                <AssessmentIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/msf/questionnaires",
            label: "Questionnaires",
            icon: (
                <FeedbackIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="360 feedback menu"
            data-cy="menu_msf"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <AssessmentOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="360 Feedback" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems.map(({ path, icon, label }) => (
                        <ListItem
                            key={path}
                            component={Link}
                            to={path}
                            disablePadding
                        >
                            <ListItemButton className="nested">
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText>{label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </List>
    );
};

export default MSFMenu;
